import { useState } from "react";

import ChunkUploadFile from "components/ChunkUploadFile";
import UploadItem from "features/main/Loads/modules/UploadItem";
import { UploadedFile } from "models/Component";
import { UPLOAD_DOCUMENT_URLS } from "constants/routes";
import { NEW_CARRIER_CATEGORY } from "constants/base";

interface INoaAttach {
  factoringId: string;
}

export default function NOAAttach({ factoringId }: Readonly<INoaAttach>) {
  const [uploadedFiles, setUploadedFiles] = useState<UploadedFile[]>([]);

  return (
    <div className="flex flex-col flex-1">
      <div className="flex flex-col items-center">
        <span>Please Attach:</span>
        <span className="text-xs font-thin">Voided Check or Direct Deposit Slip</span>
      </div>

      <ChunkUploadFile
        categories={NEW_CARRIER_CATEGORY}
        className="mt-4 desktop:flex desktop:flex-col desktop:gap-4 desktop:text-lg"
        urlCallback={
          UPLOAD_DOCUMENT_URLS({
            factoring_id: factoringId
          }).FACTORING
        }
        onUploadFinished={(files: any) => {
          const noaAttachFiles: UploadedFile[] = files.map((file: any) => ({
            name: file.name,
            size: file.fileSize,
            type: file.fileType,
            fileType: file.categories.split(","),
            url: ""
          }));
          setUploadedFiles([...uploadedFiles, ...noaAttachFiles]);
        }}
      />
      {uploadedFiles.map((file) => (
        <div key={file.name} className="-mx-2">
          <UploadItem file={file} />
        </div>
      ))}
    </div>
  );
}
